import exceljs from "exceljs";
import {saveAs} from "file-saver";
//--------------------------------------------------------------------------------------------
import {
    mimeTypeMap, 
    MyDate, 
} from "src/components/common/functions";
import { useMyStore } from "src/components/main/mainStore";
export default function Export({
    filteredFleets
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const exportFunc = () => {
        if(!filteredFleets.length){
            window.alert("No data to export.");
            return;
        }
        setShowLoader(true);
        const workbook = new exceljs.Workbook();
        workbook.creator = user.userName;
        workbook.created = new Date();
        workbook.calcProperties.fullCalcOnLoad = true;
        const worksheet = workbook.addWorksheet("My Sheet", {views: [{showGridLines: false}]});
        worksheet.state = "visible";
        worksheet.properties.defaultColWidth = 22.57;
        const rows = filteredFleets.map(post => [
            post.truckNumber,
            post.department, 
            post.location, 
            post.functionality,
            post.employee,
            post.open,
            post.insuranceCard,
            post.gps,
            post.gpsUnit,
            post.ft,
            post.ftUnit,
            post.miles,
            //------------
            post.licenseNumber,
            post.vin,
            post.year,
            post.make,
            post.model,
            post.creator,
            post.dateCreated ?? "", 
            post.updater,
            post.dateUpdated ?? "", 
            //------------
            post.background
            
        ])
        worksheet.addTable({
            name: "MyTable",
            ref: "A1",
            totalsRow: true,
            style: {
                showRowStripes: true,
            },
            columns: [
                { name: "Truck #", filterButton: true},
                { name: "Department", filterButton: true},
                { name: "Region", filterButton: true},
                { name: "Functionality", filterButton: true},
                { name: "Employee", filterButton: true},
                { name: "OPEN", filterButton: true},
                { name: "Insurance Card", filterButton: true},
                { name: "GPS", filterButton: true},
                { name: "GPS Unit", filterButton: true},
                { name: "FT", filterButton: true},
                { name: "FT Unit", filterButton: true},
                { name: "Mileage", filterButton: true},
                //-------------------------------
                { name: "License Number", filterButton: true},
                { name: "VIN", filterButton: true},
                { name: "Year", filterButton: true},
                { name: "Make", filterButton: true},
                { name: "Model", filterButton: true},
                { name: "Creator", filterButton: true},
                { name: "Date Created", filterButton: true},
                { name: "Updater", filterButton: true},
                { name: "Date Updated", filterButton: true},
                //-------------------------------
                { name: "Background", filterButton: true}
            ],
            rows: rows,
        });
        worksheet.columns.forEach(column => {
            const minLength = 18;
            let maxLength = 0;
            column["eachCell"]({ includeEmpty: true }, cell => {
                // exclude row 1 ----------
                if(cell.row === 1) return;
                //-------------------------
                const columnLength = cell.value?
                cell.value.toString().length * (cell.font?cell.font.size / 11 * 1.2:1.3)
                :minLength;
                if(columnLength > maxLength){
                    maxLength = columnLength;
                }
            });
            column.width = maxLength < minLength ? minLength : maxLength;
        });
        worksheet.getRows(2, rows.length).forEach(row => {row.alignment = { vertical: "middle", horizontal: "center", wrapText: true }});
        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: mimeTypeMap.xlsx }), `fleets export ${(new MyDate()).s()}.xlsx`);
            setShowLoader(false);
        })
    }
    return (
    <button type = "button" className = "headerButton" onClick = {exportFunc}>
        Export
    </button>
    )
}